const configs = {
  olymp: {
    title: 'Olymp Casino',
    shortTitle: 'Olymp',
    url: 'https://olymp.casino',
    links: {
      baseLink: 'olymp.casino',
      support: 'support@olymp.casino',
      help: 'help@olymp.casino',
    },
    addressBarColor: '#131F60',
    meta: {
      tileColor: '#2d89ef',
      home: {
        title: 'Olymp Casino',
        description: null,
      },
    },
  },
  olimp: {
    title: 'Olimp Casino',
    shortTitle: 'Olimp',
    url: 'https://olimp.com',
    links: {
      baseLink: 'https://olimp.com',
      support: 'support@olimp-casino.com',
      appBookMakers: 'https://olimpcom.app/',
    },
    addressBarColor: '#882211',
    meta: {
      tileColor: '#b91d47',
      home: {
        title: 'Olimp Casino',
        description: null,
      },
    },
  },
}
module.exports.configs = (platform) => {
  return configs[platform]
}

module.exports.getTitle = (platform) => {
  switch (platform) {
    case 'india': {
      return 'Olympbet India'
    }
    case 'sultan': {
      return 'Sultan Casino'
    }
    default: {
      return 'Olymp Casino'
    }
  }
}
